angular.module('picmonic-common').directive('medTermsBanner', [
  function () {
    return {
      restrict: 'E',
      templateUrl: '/templates/directives/med-terms-banner.html',
      replace: true,
      scope: {},
      controller: [
        '$scope',
        '$state',
        function ($scope, $state) {
          $scope.now = Date.now() / 1000;

          if (
            $state.current &&
            typeof $state.current.name === 'string' &&
            $state.current.name.indexOf('public.gb') === 0
          ) {
            $scope.gbPricingPage = true;
          }
        },
      ],
    };
  },
]);
